import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  resetError: null,
  resetErrorMsg: null,
  resetSuccess: null,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload }
      break
    case RESET_PASSWORD:
      state = {
        ...state,
        resetError: null,
        resetErrorMsg: null,
        resetSuccess: null
      }
      break
    case RESET_PASSWORD_SUCCESS:
      state = { ...state, resetSuccess: true }
      break
    case RESET_PASSWORD_ERROR:
      state = { ...state, resetError: true, resetErrorMsg: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
